import React from 'react';
import { withStyles } from 'material-ui/styles';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField/TextField';
import { translate } from 'react-i18next';
import Business from 'material-ui-icons/Business';

const styles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
    tableTitle: {
        color: 'var(--primary-color)',
        fontSize: 24,
        fontWeight: 300
    }
});

class SpecialDestinationTableToolbar extends React.Component {

    constructor(props) {
        super(props);
    }


    onSearchChange = (value) => {
        if (this.to) {
            clearTimeout(this.to);
            this.to = null;
        }

        this.data = value;
        this.to = setTimeout(() => this.props.fetchBackendData(this.data),
            parseInt(process.env.REACT_APP_FTS_DEBOUNCE));
    }

    onKeyPress = (event) => {
        if (event.keyCode === 13) {
            this.onSearchChange(event.target.value);
        }
    };


    render() {

        const { classes, anchorEl, t, type } = this.props;

        return (
            <Toolbar
                className={classes.root}
            >
                <div className={classes.title}>

                    <Typography className={classes.tableTitle}>
                        <Business
                            style={{
                                width: 32,
                                color: 'var(--primary-color)',
                                height: 32,
                                float: 'left'
                            }}
                        />
                        <strong style={{ paddingLeft: 8 }}
                        >
                            {t('PAGE_TITLES.SpecialDestination')} {type} 
                        </strong>
                    </Typography>
                </div>
                <div className={classes.spacer} />
                <div style={{ paddingRight: '10px' }} className={classes.actions}>
                    <TextField
                        fullWidth
                        label={t('SPECIAL_DESTINATION.SEARCH_LABEL')}
                        autoFocus={true}
                        placeholder={t('SPECIAL_DESTINATION.SEARCH_PLACE_HOLDER')}
                        style={{ width: '300px' }}
                        onChange={event => { this.onSearchChange(event.target.value); }}
                        onKeyDown={this.onKeyPress}
                    />
                </div>
                <div className={classes.spacer} />
                <div className={classes.actions}>
                    <Button
                        aria-label="SPECIAL_DESTINATION.ADD"
                        variant="raised"
                        color="primary"
                        aria-owns={anchorEl ? 'download-menu' : null}
                        style={{ minWidth: 180 }}
                        aria-haspopup="true"
                        onClick={(event) => {
                            this.props.actionHandler(null, 'ADD');
                        }}
                    >
                        {t('SPECIAL_DESTINATION.ADD')}
                        <icon>
                            <Business />
                        </icon>
                    </Button>
                </div>
            </Toolbar>

        );
    }
}

export default translate('translations')(withStyles(styles)(SpecialDestinationTableToolbar));



// WEBPACK FOOTER //
// ./src/components/SpecialDestinations/Table/SpecialDestinationTableToolbar.js